<br>

<div style="width: auto; overflow: auto">
  <app-common-list-table
          [request]="getRequest"
          [cols]="cols"
          [filtering]="filter"
          [globalConditionalStyle]="globalConditionalStyle"
          [globalVisualTransform]="globalVisualTransform"
          [actionButtonText]="btnAnadir"
          (actionButtonClick)="add()">
    <ng-template #header>
      <div *ngIf="env.rol === 'admin'" class="d-flex justify-content-start align-content-center">
          <p-toggleswitch
                  [style]="{marginLeft: '15px', marginRight: '10px'}"
                  [(ngModel)]="showAllCampos"
                  (onChange)="changeShowAll();filterCampos()">
          </p-toggleswitch>
          <p style="color: white; font-size: 1.2em; margin-bottom: 0">Mostrar todos</p>
      </div>
    </ng-template>
    <ng-template #thEnd>
      <th>
        <p class="d-flex justify-content-center"
           style="margin-bottom: 0">Acciones</p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
      <td>
        <app-action-buttons
          [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                (editRowButtonEvent)="edit(data.data)"
                (deleteRowButtonEvent)="show('delete', data.data)"
                (showRowButtonEvent)="show('info', data.data)">
        </app-action-buttons>
      </td>
    </ng-template>
  </app-common-list-table>
</div>

@if (form; as modalForm) {
<app-modals
  [view]="this"
  [form]="modalForm.formFields"
  [serverUrl]="env.serverURL"
  [previousData]="model"
  [recordHasAssociatedData]="true"
  [getRequest]="getRequest"
  [deleteRequest]="deleteRequest">
</app-modals>
}